import { registerAgentWidget } from 'lib.components/src/components/AgentWidgets';

import MatchDecisionWidget from './MatchDecisionWidget';
import MatchQuestionWidget from './MatchQuestionWidget';
import MemorySavedWidget from './MemorySavedWidget';

// the app's agent-widget set: meta.kind → component. Imported once at app
// startup; every agent surface rendering AiAssistantMessage picks these up
registerAgentWidget('match_decision', MatchDecisionWidget);
registerAgentWidget('match_question', MatchQuestionWidget);
registerAgentWidget('memory_saved', MemorySavedWidget);
